<h2>Tags</h2>
<div class="grid">
  <div class="col-12">
    <p-table [value]="tagCategories" [rowTrackBy]="rowTrackBy" editMode="row" dataKey="id" [expandedRowKeys]="expandedRowKeys" styleClass="category-table" #table>
      <ng-template #header>
        <tr>
          <th style="width: 5rem"></th>
          <th>Tag-Kategorien</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-category let-editingRow="editing" let-expanded="expanded">
        <tr [pEditableRow]="category">
          <td>
            <p-button type="button" pRipple [pRowToggler]="category" [text]="true" [rounded]="true" [plain]="true"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" ariaLabel="Umklappen" />
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="output">
                {{category.label}}
              </ng-template>
              <ng-template pTemplate="input">
                <input pInputText [(ngModel)]="category.label" class="bg-white" (keydown.enter)="updateCategory(category)">
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="actionColumn">
            @if (editingRow) {
              <p-button icon="pi pi-save" pSaveEditableRow (click)="updateCategory(category)" ariaLabel="Speichern"></p-button>
            }
            @if (editingRow) {
              <p-button icon="pi pi-times" pCancelEditableRow (click)="onCategoryEditCancel(category)" ariaLabel="Abbrechen"></p-button>
            }
            @if (!editingRow) {
              <p-button icon="pi pi-pencil" pInitEditableRow (click)="onCategoryEditInit(category)" ariaLabel="Bearbeiten"></p-button>
            }
            @if (!editingRow) {
              <p-button icon="pi pi-trash" (click)="deleteCategory(category)" ariaLabel="Löschen"></p-button>
            }
          </td>
        </tr>
      </ng-template>
      <ng-template #expandedrow let-category>
        <tr class="expanded-row">
          <td colspan="3">
            <p-table [value]="tagsPerCategory[category.id]" [rowTrackBy]="rowTrackBy" editMode="row"
              dataKey="id" #tagTable>
              <ng-template #body let-tag let-editingRow="editing" let-rowIndex="rowIndex">
                <tr [pEditableRow]="tag">
                  <td class="w-5rem" [style]="rowIndex<tagsPerCategory[category.id].length-1?'border: none;':''">@if (rowIndex === 0) {
                    <span>Tags:</span>
                  }</td>
                  <td>
                    <p-cellEditor>
                      <ng-template pTemplate="output">
                        {{tag.text}}
                      </ng-template>
                      <ng-template pTemplate="input">
                        <input pInputText [(ngModel)]="tag.text" (keydown.enter)="updateTag(category.id, tag)">
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td class="actionColumn">
                    @if (editingRow) {
                      <p-button icon="pi pi-save" pSaveEditableRow (click)="updateTag(category.id, tag)" ariaLabel="Speichern"></p-button>
                    }
                    @if (editingRow) {
                      <p-button icon="pi pi-times" pCancelEditableRow (click)="onTagEditCancel(category.id, tag)" ariaLabel="Abbrechen"></p-button>
                    }
                    @if (!editingRow) {
                      <p-button icon="pi pi-pencil" pInitEditableRow (click)="onTagEditInit(tag)" ariaLabel="Bearbeiten"></p-button>
                    }
                    @if (!editingRow) {
                      <p-button icon="pi pi-trash" (click)="deleteTag(category.id, tag)" ariaLabel="Löschen"></p-button>
                    }
                  </td>
                </tr>
              </ng-template>
              <ng-template #summary>
                <div class="h-full flex align-items-center justify-content-between" style="padding-top: 0.25rem;">
                  <div>@if (tagsPerCategory[category.id].length===0) {
                    <span>Noch keine Tags für diese Kategorie angelegt.</span>
                  }</div>
                  <p-button label="Tag hinzufügen" icon="pi pi-plus" (click)="createTag(category.id, tagTable)" ariaLabel="Tag hinzufügen"></p-button>
                </div>
              </ng-template>
            </p-table>
          </td>
        </tr>
      </ng-template>
      <ng-template #summary>
        <div class="flex gap-2 justify-content-end align-items-center p-3">
          <p-button label="Tag-Kategorie hinzufügen" icon="pi pi-plus" (click)="createCategory(table)" ariaLabel="Tag-Kategorie hinzufügen"></p-button>
        </div>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="3">
            Noch keine Tag-Kategorien angelegt.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>